import React from "react";
import { Link } from "react-router-dom";
import Blog_1 from "../../../assets/images/home_page_7/blog/01.png";
import Blog_2 from "../../../assets/images/home_page_7/blog/02.png";
import Blog_3 from "../../../assets/images/home_page_7/blog/03.png";

const blogData = [
  {
    id: 1,
    imgSrc: Blog_1,
    date: "15",
    month: "March",
    title: "The Importance of Soil Health in Agricultural Production",
    comments: 5,
    author: "Admin",
    link: "/BlogDetails",
  },
  {
    id: 2,
    imgSrc: Blog_2,
    date: "15",
    month: "March",
    title: "Pest Management in Agriculture Natural and Chemical Solutions",
    comments: 5,
    author: "Admin",
    link: "/BlogDetails",
  },
  {
    id: 3,
    imgSrc: Blog_3,
    date: "15",
    month: "March",
    title: "The Role of Genetics in Modern Agricultural Production",
    comments: 5,
    author: "Admin",
    link: "/BlogDetails",
  },
];

const Blog = () => {
  return (
    <section id="blog-seven" className="blog-seven-main-block">
      <div className="container">
        <div className="section text-center">
          <h2 className="section-heading">Discover Your Digital Dreams</h2>
          <p>
            For your car we will do everything advice, repairs, and maintenance.
            We are the preferred choice by many car owners because our experience
            and knowledge are self-evident.
          </p>
        </div>
        <div className="row">
          {blogData.map((blog) => (
            <div key={blog.id} className="col-lg-4 col-md-4">
              <div className="blog-seven-block">
                <div className="blog-seven-img">
                  <Link to={blog.link} title={blog.title}>
                    <img src={blog.imgSrc} className="img-fluid" alt={blog.title} />
                  </Link>
                  <span className="badge text-bg-primary">
                    <span>{blog.date}</span>
                    <br />
                    {blog.month}
                  </span>
                </div>
                <div className="blog-seven-dtl">
                  <ul className="blog-tags">
                    <li>
                      <Link to={blog.link} title="Comments">
                        <i className="flaticon-comment-1" /> Comments ({blog.comments})
                      </Link>
                    </li>
                    <li>
                      <Link to={blog.link} title="Author">
                        <i className="flaticon-avatar" /> By {blog.author}
                      </Link>
                    </li>
                  </ul>
                  <h4 className="blog-seven-title">
                    <Link to={blog.link} title={blog.title}>
                      {blog.title}
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
